import ConditionalToolTip from "components/design/conditionalToolTip";
import { Divider } from "components/design/Divider";
import { Switch } from "components/DesignSystem/Switch/Switch";
import { useChannelAiStatus } from "hooks/useChannelAiStatus";
import { useChannelEscalationStatus } from "hooks/useChannelEscalationStatus";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import { useToggleChannelAiMutation } from "store/apis/chatAiToggle";
import { HUMAN_SUPPORT_STATUS } from "store/apis/chatHumanSupport";
import { BackendError } from "types/utils/error";

export const AiToggle = () => {
  const { isAdmin } = useRoleBasedView();
  const { alertToast } = useToast();
  const { channelId, isAiEnabled } = useChannelAiStatus();
  const { escalationStatus } = useChannelEscalationStatus();
  const [toggleChannelAi, { isLoading: isTogglingAi }] =
    useToggleChannelAiMutation();

  const handleAiToggle = async () => {
    try {
      await toggleChannelAi({ channelId }).unwrap();
    } catch (err) {
      alertToast({
        message:
          (err as BackendError).data?.error?.message ?? "Something went wrong",
      });
    }
  };

  if (
    !isAdmin ||
    escalationStatus === HUMAN_SUPPORT_STATUS.ACTIVE ||
    escalationStatus === HUMAN_SUPPORT_STATUS.PENDING
  ) {
    return null;
  }

  return (
    <div className="t-flex t-gap-2 t-text-body">
      <ConditionalToolTip
        condition={
          isAiEnabled ? (
            <div className="t-text-start">
              Turn off to stop AI from replying in this
              <br />
              channel
            </div>
          ) : (
            <div className="t-text-start">
              Turn on to let AI reply to queries in this
              <br />
              channel
            </div>
          )
        }
        side="bottom"
        align="end"
      >
        <div className="t-flex t-flex-row-reverse t-gap-2 t-items-center">
          <Switch
            className="t-peer"
            size="small"
            name="ai-enable"
            id="ai-enable"
            checked={isAiEnabled}
            disabled={isTogglingAi}
            onCheckedChange={() => void handleAiToggle()}
          />
          <label
            htmlFor="ai-enable"
            className="t-select-none peer-data-[state=checked]:t-text-purple peer-data-[state=unchecked]:t-text-neutral t-text-body t-font-semibold"
          >
            AI
          </label>
        </div>
      </ConditionalToolTip>

      <Divider orientation="vertical" />
    </div>
  );
};
